import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { LuxonHelpersService } from '@tiltgroup/web-components';

@Pipe({
  name: 'lastUpdatedText',
})
export class LastUpdatedTextPipe implements PipeTransform {
  private luxonHelpersService = inject(LuxonHelpersService);

  transform(value: string): string {
    if (!value) {
      return '-';
    }

    const date = this.luxonHelpersService.getLuxonDate(value, 'UTC');
    const now = DateTime.now().setZone('UTC');
    const diff = now.startOf('day').diff(date.startOf('day'), 'days').days;
    const displayDate = this.luxonHelpersService.setDateTimeZone(date, 'local');
    const timeStr = displayDate.toFormat('HH:mm');

    if (diff < 1) {
      return `Today at ${timeStr}`;
    } else if (diff < 2) {
      return `Yesterday at ${timeStr}`;
    } else if (diff < 7) {
      return `${Math.floor(diff)} days ago`;
    } else {
      const weeks = Math.floor(diff / 7);
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    }
  }
}
